import { useChatRoom } from '@commenda/api';
import { IconButton, Icons, Tooltip } from '@commenda/kakashi';
import { ChatRoomModel, cn } from '@commenda/utils';

interface ChatPanelToggleProps {
  chatRoomId: string | null;
  isOpen: boolean;
  onClick: () => void;
}

const ChatPanelToggle = ({
  chatRoomId,
  isOpen,
  onClick,
}: ChatPanelToggleProps) => {
  const { data: chatRoomResponse } = useChatRoom({ chatRoomId });

  const room = chatRoomResponse?.chatRoom;
  const totalUnread = room != null ? ChatRoomModel.getTotalUnread(room) : 0;
  const hasUnread = totalUnread > 0;

  const label = isOpen ? 'Hide chat panel' : 'Show chat panel';

  return (
    <Tooltip content={label}>
      <IconButton
        size="lg"
        aria-label={label}
        aria-pressed={isOpen}
        onClick={onClick}
        className={cn(isOpen && 'bg-button-tertiary-bg-hover text-fg-brand')}
        icon={
          <div className="relative">
            <Icons.LayoutRight className="size-5" />
            {hasUnread && (
              <div
                className="absolute top-[-2px] right-[-2px] w-3 h-3 bg-blue-500 rounded-full border-2 border-white"
                aria-label={`${totalUnread} unread messages`}
              />
            )}
          </div>
        }
      />
    </Tooltip>
  );
};

export { ChatPanelToggle };
